import { createAsyncActions } from '~/utils/store';

export const LOAD_DIVIDAS = createAsyncActions('@@DIVIDAS_TRIBUTARIAS/LOAD');
export const CREATE_DIVIDA = createAsyncActions('@@DIVIDAS_TRIBUTARIAS/CREATE');
export const UPDATE_DIVIDA = createAsyncActions('@@DIVIDAS_TRIBUTARIAS/UPDATE');
export const DELETE_DIVIDA = createAsyncActions('@@DIVIDAS_TRIBUTARIAS/DELETE');
export const ARCHIVE_DIVIDA = createAsyncActions('@@DIVIDAS_TRIBUTARIAS/ARCHIVE');
export const UNARCHIVE_DIVIDA = createAsyncActions('@@DIVIDAS_TRIBUTARIAS/UNARCHIVE');

export const loadDividas = (params) => ({
    type: LOAD_DIVIDAS.INIT,
    payload: {
        request: {
            method: 'GET',
            url: '/dividas-tributarias',
            params
        }
    }
});

export const createDivida = (formData) => ({
    type: CREATE_DIVIDA.INIT,
    payload: {
        request: {
            method: 'POST',
            url: '/dividas-tributarias',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    }
});

export const updateDivida = (id, formData) => ({
    type: UPDATE_DIVIDA.INIT,
    payload: {
        request: {
            method: 'POST',
            url: '/dividas-tributarias/' + id,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        },
        id
    }
});

export const deleteDivida = (id) => ({
    type: DELETE_DIVIDA.INIT,
    payload: {
        request: {
            method: 'DELETE',
            url: '/dividas-tributarias/' + id
        },
        id
    }
});

export const archiveDivida = (id, archiveNote) => ({
    type: ARCHIVE_DIVIDA.INIT,
    payload: {
        request: {
            method: 'POST',
            url: '/dividas-tributarias/' + id + '/archive',
            data: { archive_note: archiveNote }
        },
        id
    }
});

export const unarchiveDivida = (id) => ({
    type: UNARCHIVE_DIVIDA.INIT,
    payload: {
        request: {
            method: 'POST',
            url: '/dividas-tributarias/' + id + '/unarchive'
        },
        id
    }
});
